import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Loading from '../../components/Loading';

import { connect } from 'react-redux';
import * as entregaActions from '../../actions/entregas';
import { getEntregadores } from '../../actions/entregadores';

import Titulo from '../../components/Texto/Titulo';
import Pesquisa from '../../components/Inputs/Pesquisa';
import DynamicTable from '../../components/Table/DynamicTable';
import Paginacao from '../../components/Paginacao/Simples';
import {
	ENTREGA_AGENDADA,
	LISTA_SITUACOES,
	PEDIDO_ENTREGUE,
	PEDIDO_NAO_ENTREGUE,
	entregaStatusListagemLabel,
	entregaStatusListagemPayClass,
} from '../../constants/entregaStatus';
import { PERIODOS_ENTREGA_FILTRO } from '../../constants/entregaPeriodos';
import EntregaDetalhesExpand from './EntregaDetalhesExpand';
import EntregasDashboardCards from './EntregasDashboardCards';
import { openWhatsAppUrl } from '../../utils/openWhatsAppUrl';
import { defaultEntregasDateRange } from '../../utils/entregasDefaultDateRange';
import { verifyAdmin } from '../../utils/verify-admin';

const SEM_LOTE_SELECT = '__sem_lote';
const STORAGE_KEY_ENTREGAS_DASHBOARD = 'entregas.dashboardFiltro';

function loadPersistedEntregaDashboardFiltro(){
	try{
		const raw = localStorage.getItem(STORAGE_KEY_ENTREGAS_DASHBOARD);
		if(!raw) return null;
		const parsed = JSON.parse(raw);
		if(!parsed || parsed.v !== 1 || typeof parsed.kind !== 'string') return null;
		if(parsed.kind === 'total') return { statusFiltro: '', semLoteFiltro: false };
		if(parsed.kind === 'semLote') return { statusFiltro: '', semLoteFiltro: true };
		if(LISTA_SITUACOES.includes(parsed.kind)) return { statusFiltro: parsed.kind, semLoteFiltro: false };
		return null;
	}catch(e){
		return null;
	}
}

function persistEntregaDashboardFiltro(kind){
	try{
		localStorage.setItem(STORAGE_KEY_ENTREGAS_DASHBOARD, JSON.stringify({ v: 1, kind }));
	}catch(e){}
}

class Entregas extends Component {

	state = {
		pesquisa: "",
		atual: 0,
		limit: 30,
		refreshing: false,
		bairroFiltro: "",
		...(loadPersistedEntregaDashboardFiltro() || { statusFiltro: '', semLoteFiltro: false }),
		...defaultEntregasDateRange(),
		filtroEntregadorId: "",
		periodoEntregaFiltro: "",
		batchEntregadorId: "",
		selectedIds: {},
		filtrosExtrasAbertos: false,
	}

	buildListaFilters(){
		const { bairroFiltro, statusFiltro, semLoteFiltro, dataInicio, dataFim, filtroEntregadorId, periodoEntregaFiltro, pesquisa } = this.state;
		const f = {};
		if(bairroFiltro) f.bairro = bairroFiltro;
		if(semLoteFiltro) f.semLote = true;
		else if(statusFiltro){
			f.status = statusFiltro;
			if(statusFiltro === ENTREGA_AGENDADA) f.comLote = true;
		}
		if(dataInicio && dataFim){
			f.dataInicio = dataInicio;
			f.dataFim = dataFim;
		}
		if(filtroEntregadorId) f.entregadorId = filtroEntregadorId;
		if(periodoEntregaFiltro) f.shippingPeriod = periodoEntregaFiltro;
		if(pesquisa && pesquisa.trim()) f.buscaId = pesquisa.trim();
		if(statusFiltro === PEDIDO_ENTREGUE) f.sortType = 'atualizado_decrescente';
		return f;
	}

	/** Mesmos critérios da lista, exceto situação — alinhado ao endpoint `admin/resumo`. */
	buildResumoFilters(){
		const { bairroFiltro, dataInicio, dataFim, filtroEntregadorId, periodoEntregaFiltro, pesquisa } = this.state;
		const f = {};
		if(bairroFiltro) f.bairro = bairroFiltro;
		if(dataInicio && dataFim){
			f.dataInicio = dataInicio;
			f.dataFim = dataFim;
		}
		if(filtroEntregadorId) f.entregadorId = filtroEntregadorId;
		if(periodoEntregaFiltro) f.shippingPeriod = periodoEntregaFiltro;
		if(pesquisa && pesquisa.trim()) f.buscaId = pesquisa.trim();
		return f;
	}

	getResumo(){
		const { usuario } = this.props;
		if(!usuario) return;
		const filters = this.buildResumoFilters();
		this.props.getEntregasResumo(usuario.loja, filters);
	}

	getEntregas(){
		const { atual, limit } = this.state;
		const { usuario } = this.props;
		if(!usuario) return Promise.resolve();
		const loja = usuario.loja;
		return this.props.getEntregas(atual, limit, loja, this.buildListaFilters());
	}

	/** Lista com skeleton (Pedidos/Orders): gradiente `.Table.refreshing`. */
	_fetchListaComIndicador = () => {
		this.setState({ refreshing: true });
		return Promise.resolve(this.getEntregas()).finally(() => {
			this.setState({ refreshing: false });
		});
	}

	/** Resumo dos cards + lista (filtros, cards do dashboard, refresh manual). */
	_fetchListaEResumoComIndicador = () => {
		this.getResumo();
		return this._fetchListaComIndicador();
	}

	componentDidMount(){
		this.getEntregas();
		this.getResumo();
		const { usuario } = this.props;
		if(usuario && usuario.loja){
			this.props.getEntregasBairros(usuario.loja);
			this.props.getEntregadores(usuario.loja);
		}
		this._refreshResumoListener = () => { this._fetchListaEResumoComIndicador(); };
		window.addEventListener('entregas-resumo-refresh', this._refreshResumoListener);
		/** Só resumo dos cards (sem skeleton na lista). `window.focus` foi removido — dispara ao Ctrl+Tab, Alt+Tab etc. */
		this._onVisibilityEntregas = () => {
			if(document.visibilityState !== 'visible' || !this.props.usuario) return;
			this.getResumo();
		};
		document.addEventListener('visibilitychange', this._onVisibilityEntregas);
		this._onStorageEntregasResumo = (e) => {
			if(e.key === 'entregas-resumo-bump' && e.newValue) this._fetchListaEResumoComIndicador();
		};
		window.addEventListener('storage', this._onStorageEntregasResumo);
		this._resumoPollTimer = window.setInterval(() => {
			if(document.visibilityState !== 'visible') return;
			this.getResumo();
		}, 45000);
	}

	componentWillUnmount(){
		if(this._refreshResumoListener){
			window.removeEventListener('entregas-resumo-refresh', this._refreshResumoListener);
		}
		if(this._onVisibilityEntregas){
			document.removeEventListener('visibilitychange', this._onVisibilityEntregas);
		}
		if(this._onStorageEntregasResumo){
			window.removeEventListener('storage', this._onStorageEntregasResumo);
		}
		if(this._resumoPollTimer){
			clearInterval(this._resumoPollTimer);
		}
	}

	componentDidUpdate(prevProps){
		if(!prevProps.usuario && this.props.usuario){
			this.getEntregas();
			this.getResumo();
			this.props.getEntregasBairros(this.props.usuario.loja);
			this.props.getEntregadores(this.props.usuario.loja);
		}
	}

	handleSubmitPesquisa(){
		this.setState({ atual: 0, selectedIds: {} }, () => {
			this._fetchListaEResumoComIndicador();
		});
	}

	onChangePesquisa = (ev) => this.setState({ pesquisa: ev.target.value });

	onBairroChange = (ev) => {
		const bairroFiltro = ev.target.value;
		this.setState({ bairroFiltro, atual: 0, selectedIds: {} }, () => {
			this._fetchListaEResumoComIndicador();
		});
	}

	onSituationFilterChange = (ev) => {
		const v = ev.target.value;
		if(v === SEM_LOTE_SELECT){
			persistEntregaDashboardFiltro('semLote');
			this.setState({ semLoteFiltro: true, statusFiltro: '', atual: 0, selectedIds: {} }, () => {
				this._fetchListaEResumoComIndicador();
			});
		}else if(!v){
			persistEntregaDashboardFiltro('total');
			this.setState({ semLoteFiltro: false, statusFiltro: '', atual: 0, selectedIds: {} }, () => {
				this._fetchListaEResumoComIndicador();
			});
		}else{
			persistEntregaDashboardFiltro(v);
			this.setState({ semLoteFiltro: false, statusFiltro: v, atual: 0, selectedIds: {} }, () => {
				this._fetchListaEResumoComIndicador();
			});
		}
	}

	onDashboardCardClick = (kind) => {
		if(kind === 'total'){
			persistEntregaDashboardFiltro('total');
			this.setState({ statusFiltro: '', semLoteFiltro: false, atual: 0, selectedIds: {} }, () => {
				this._fetchListaEResumoComIndicador();
			});
		}else if(kind === 'semLote'){
			persistEntregaDashboardFiltro('semLote');
			this.setState({ semLoteFiltro: true, statusFiltro: '', atual: 0, selectedIds: {} }, () => {
				this._fetchListaEResumoComIndicador();
			});
		}else{
			persistEntregaDashboardFiltro(kind);
			this.setState({ statusFiltro: kind, semLoteFiltro: false, atual: 0, selectedIds: {} }, () => {
				this._fetchListaEResumoComIndicador();
			});
		}
	}

	limparFiltrosEntregas = () => {
		persistEntregaDashboardFiltro('total');
		this.setState({
			...defaultEntregasDateRange(),
			bairroFiltro: '',
			statusFiltro: '',
			semLoteFiltro: false,
			filtroEntregadorId: '',
			periodoEntregaFiltro: '',
			pesquisa: '',
			atual: 0,
			selectedIds: {},
		}, () => {
			this._fetchListaEResumoComIndicador();
		});
	}

	onDataInicioChange = (ev) => {
		const dataInicio = ev.target.value;
		this.setState({ dataInicio, atual: 0, selectedIds: {} }, () => {
			this._fetchListaEResumoComIndicador();
		});
	}

	onDataFimChange = (ev) => {
		const dataFim = ev.target.value;
		this.setState({ dataFim, atual: 0, selectedIds: {} }, () => {
			this._fetchListaEResumoComIndicador();
		});
	}

	onFiltroEntregadorChange = (ev) => {
		const filtroEntregadorId = ev.target.value;
		this.setState({ filtroEntregadorId, atual: 0, selectedIds: {} }, () => {
			this._fetchListaEResumoComIndicador();
		});
	}

	onPeriodoEntregaChange = (ev) => {
		const periodoEntregaFiltro = ev.target.value;
		this.setState({ periodoEntregaFiltro, atual: 0, selectedIds: {} }, () => {
			this._fetchListaEResumoComIndicador();
		});
	}

	changeNumeroAtual = (atual) => {
		this.setState({ atual }, () => {
			this._fetchListaComIndicador();
		});
	}

	refreshList = () => {
		this._fetchListaEResumoComIndicador();
	}

	handlePurgeEntregasAntigas = () => {
		const { usuario, purgeEntregasAntigas } = this.props;
		if(!usuario || !verifyAdmin(usuario, 'owner')) return;
		const entrada = window.prompt(
			'Informe a data limite (DD/MM/AAAA). Serão excluídas todas as entregas anteriores a essa data.\nExemplo: 10/01/2026',
		);
		if(entrada === null) return;
		const dataLimite = String(entrada).trim();
		const m = dataLimite.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
		if(!m){
			window.alert('Data inválida. Use o formato DD/MM/AAAA (ex.: 10/01/2026).');
			return;
		}
		const day = parseInt(m[1], 10);
		const month = parseInt(m[2], 10) - 1;
		const year = parseInt(m[3], 10);
		const parsed = new Date(year, month, day);
		if(parsed.getFullYear() !== year || parsed.getMonth() !== month || parsed.getDate() !== day){
			window.alert('Data inválida. Verifique dia, mês e ano.');
			return;
		}
		const dataStr = parsed.toLocaleDateString('pt-BR');
		const msg1 = [
			'Esta ação é irreversível.',
			`Serão excluídas TODAS as entregas (qualquer situação) cuja data de entrega agendada é anterior a ${dataStr}.`,
			'Se a data de entrega não puder ser lida, usa-se a data de criação do registro da entrega.',
			'Os pedidos permanecem, mas perdem o vínculo com a entrega.',
			'Deseja continuar?',
		].join('\n\n');
		if(!window.confirm(msg1)) return;
		if(!window.confirm('Confirma a exclusão definitiva?')) return;
		purgeEntregasAntigas(usuario.loja, dataLimite).then((data) => {
			if(!data) return;
			if(data.status && data.message){
				window.alert(data.message);
				return;
			}
			if(data.errors){
				window.alert(typeof data.errors === 'string' ? data.errors : 'Não autorizado ou dados inválidos.');
				return;
			}
			if(data.error){
				window.alert(typeof data.error === 'string' ? data.error : 'Erro ao processar.');
				return;
			}
			const n = data.removidas != null ? data.removidas : 0;
			const extra = data.mensagem ? `\n\n${data.mensagem}` : '';
			window.alert(`Removidas ${n} entrega(s).${extra}`);
			this._fetchListaEResumoComIndicador();
		});
	}

	entregaPodeSelecionar = (entrega) => {
		if(!entrega) return false;
		return entrega.status !== PEDIDO_ENTREGUE;
	}

	/**
	 * Com lote ainda ativo: não atribuir outro lote enquanto agendada ou já saiu para entrega (evita lote duplicado sem desatribuir).
	 * Reentrega (Pedido não entregue + lote atual): pode atribuir novo lote direto — a API registra `reentrega_lote` sem exigir remover o lote antes.
	 */
	podeAtribuirLoteSelecionadas = () => {
		const docs = (this.props.entregas && this.props.entregas.docs) ? this.props.entregas.docs : [];
		const sel = this.state.selectedIds;
		const keys = Object.keys(sel);
		for(let i = 0; i < keys.length; i++){
			if(!sel[keys[i]]) continue;
			let e = null;
			for(let d = 0; d < docs.length; d++){
				if(docs[d] && String(docs[d]._id) === keys[i]){
					e = docs[d];
					break;
				}
			}
			if(!e || !e.loteAtual) continue;
			if(e.status === PEDIDO_NAO_ENTREGUE) continue;
			if(e.status !== PEDIDO_ENTREGUE) return false;
		}
		return true;
	}

	toggleSelect = (id) => {
		const sid = String(id);
		const docs = (this.props.entregas && this.props.entregas.docs) ? this.props.entregas.docs : [];
		let entrega = null;
		for(let d = 0; d < docs.length; d++){
			if(docs[d] && String(docs[d]._id) === sid){
				entrega = docs[d];
				break;
			}
		}
		if(entrega && !this.entregaPodeSelecionar(entrega)) return;
		this.setState((prev) => {
			const next = { ...prev.selectedIds };
			if(next[sid]) delete next[sid];
			else next[sid] = true;
			return { selectedIds: next };
		});
	}

	togglePageSelection = () => {
		const docs = (this.props.entregas && this.props.entregas.docs) ? this.props.entregas.docs : [];
		const ids = [];
		for(let i = 0; i < docs.length; i++){
			if(docs[i] && docs[i]._id && this.entregaPodeSelecionar(docs[i])) ids.push(String(docs[i]._id));
		}
		if(!ids.length) return;
		let allSelected = true;
		for(let j = 0; j < ids.length; j++){
			if(!this.state.selectedIds[ids[j]]){ allSelected = false; break; }
		}
		this.setState((prev) => {
			const next = { ...prev.selectedIds };
			if(allSelected){
				for(let k = 0; k < ids.length; k++) delete next[ids[k]];
			}else{
				for(let m = 0; m < ids.length; m++) next[ids[m]] = true;
			}
			return { selectedIds: next };
		});
	}

	clearSelection = () => this.setState({ selectedIds: {} });

	selectAllDoBairro = () => {
		const { usuario, bairroFiltro } = this.state;
		if(!usuario || !usuario.loja || !bairroFiltro) return;
		this.props.fetchEntregasListaBairro(usuario.loja, bairroFiltro, this.buildListaFilters())
			.then((data) => {
				const docs = data && data.entregas && data.entregas.docs ? data.entregas.docs : [];
				this.setState((prev) => {
					const next = { ...prev.selectedIds };
					for(let i = 0; i < docs.length; i++){
						if(docs[i] && docs[i]._id && this.entregaPodeSelecionar(docs[i])) next[String(docs[i]._id)] = true;
					}
					return { selectedIds: next };
				});
			});
	}

	onBatchEntregadorChange = (ev) => this.setState({ batchEntregadorId: ev.target.value });

	_ehErroLote = (data) => {
		if(!data) return true;
		if(data.status && data.message){
			window.alert(data.message);
			return true;
		}
		if(data.error){
			window.alert(typeof data.error === 'string' ? data.error : 'Erro ao processar.');
			return true;
		}
		return false;
	}

	/**
	 * WhatsApp: todas com lote, mesmo entregador (podem ser lotes diferentes).
	 * Ordem das ids preserva a ordem de seleção na lista atual.
	 */
	getWhatsAppSelecaoValida = () => {
		const ids = [];
		const sel = this.state.selectedIds;
		const keys = Object.keys(sel);
		for(let k = 0; k < keys.length; k++){
			if(sel[keys[k]]) ids.push(keys[k]);
		}
		if(!ids.length) return { erro: 'Selecione ao menos uma entrega.' };
		const docs = (this.props.entregas && this.props.entregas.docs) ? this.props.entregas.docs : [];
		let entregadorId = null;
		for(let u = 0; u < ids.length; u++){
			const sid = ids[u];
			let e = null;
			for(let d = 0; d < docs.length; d++){
				if(docs[d] && String(docs[d]._id) === sid){
					e = docs[d];
					break;
				}
			}
			if(!e) return { erro: 'Para esta ação, todas as entregas selecionadas precisam aparecer na página atual (ajuste a página ou a seleção).' };
			if(!e.loteAtual) return { erro: 'Uma das entregas selecionadas ainda não possui lote. Atribua um entregador primeiro.' };
			const eid = e.entregador && (e.entregador._id ? String(e.entregador._id) : String(e.entregador));
			if(!eid) return { erro: 'Uma das entregas selecionadas ainda não possui entregador.' };
			if(entregadorId === null) entregadorId = eid;
			else if(entregadorId !== eid) return { erro: 'Selecione apenas entregas do mesmo entregador.' };
		}
		return { entregaIds: ids };
	}

	podeNotificarWhatsAppLote = () => {
		return !this.getWhatsAppSelecaoValida().erro;
	}

	_loteRefParaString = (ref) => {
		if(ref == null) return "";
		if(typeof ref === "string") return ref;
		if(ref._id != null) return String(ref._id);
		return String(ref);
	}

	/**
	 * Pode remover do lote no painel (inclui após "Saiu para entrega" — troca de entregador).
	 * Bloqueia só após confirmação no app (resultado).
	 */
	podeDesatribuirLote = (entrega) => {
		if(!entrega || !entrega.loteAtual) return false;
		const lid = this._loteRefParaString(entrega.loteAtual);
		const tentativas = entrega.tentativas || [];
		for(let i = 0; i < tentativas.length; i++){
			const t = tentativas[i];
			if(!t || !t.lote) continue;
			const tl = this._loteRefParaString(t.lote);
			if(tl === lid){
				if(t.resultado) return false;
				return true;
			}
		}
		return false;
	}

	handleDesatribuirLote = (entregaId) => {
		if(!window.confirm('Remover esta entrega do lote? O vínculo com o entregador será desfeito nesta etapa.')) return;
		const { usuario } = this.props;
		this.props.loteRemoverEntrega(usuario.loja, entregaId)
			.then((data) => {
				if(this._ehErroLote(data)) return;
				this.refreshList();
			});
	}

	/**
	 * Pelo menos uma entrega selecionada visível na página pode ser removida do lote
	 * (mesmas regras do botão X na coluna Lote).
	 */
	algumaSelecionadaPodeDesatribuirLote = () => {
		const docs = (this.props.entregas && this.props.entregas.docs) ? this.props.entregas.docs : [];
		const sel = this.state.selectedIds;
		const keys = Object.keys(sel);
		for(let i = 0; i < keys.length; i++){
			if(!sel[keys[i]]) continue;
			let e = null;
			for(let d = 0; d < docs.length; d++){
				if(docs[d] && String(docs[d]._id) === keys[i]){
					e = docs[d];
					break;
				}
			}
			if(e && this.podeDesatribuirLote(e)) return true;
		}
		return false;
	}

	/** Remove do lote todas as selecionadas que ainda podem ser desatribuídas; depois use outro entregador + Atribuir lote. */
	handleDesatribuirLoteSelecionadas = () => {
		const { usuario } = this.props;
		const docs = (this.props.entregas && this.props.entregas.docs) ? this.props.entregas.docs : [];
		const idList = [];
		const sel = this.state.selectedIds;
		const ks = Object.keys(sel);
		for(let i = 0; i < ks.length; i++){
			if(sel[ks[i]]) idList.push(ks[i]);
		}
		if(!idList.length){
			window.alert('Selecione ao menos uma entrega.');
			return;
		}
		const toRemove = [];
		for(let u = 0; u < idList.length; u++){
			const sid = idList[u];
			let e = null;
			for(let d = 0; d < docs.length; d++){
				if(docs[d] && String(docs[d]._id) === sid){
					e = docs[d];
					break;
				}
			}
			if(!e){
				window.alert('Para remover do lote em lote, todas as entregas selecionadas precisam aparecer na página atual. Ajuste a página ou a seleção.');
				return;
			}
			if(this.podeDesatribuirLote(e)) toRemove.push(sid);
		}
		if(!toRemove.length){
			window.alert('Nenhuma entrega selecionada pode ser removida do lote neste momento (sem lote, ou já confirmada no app pelo entregador).');
			return;
		}
		const skipped = idList.length - toRemove.length;
		let msg = 'Remover do lote as entregas selecionadas? O vínculo com o entregador atual será desfeito. Em seguida escolha outro entregador e use Atribuir lote.';
		if(skipped > 0){
			msg = `${skipped} entrega(s) não podem ser removidas e serão ignoradas. ` + msg;
		}
		if(!window.confirm(msg)) return;
		let chain = Promise.resolve();
		for(let r = 0; r < toRemove.length; r++){
			const eid = toRemove[r];
			chain = chain.then(() =>
				this.props.loteRemoverEntrega(usuario.loja, eid).then((data) => {
					if(this._ehErroLote(data)) return Promise.reject(new Error('lote'));
				})
			);
		}
		chain
			.then(() => {
				window.alert(`${toRemove.length} entrega(s) removida(s) do lote. Escolha o entregador e use Atribuir lote.`);
				this.refreshList();
			})
			.catch((err) => {
				if(err && err.message === 'lote') return;
			});
	}

	handleLoteAtribuir = () => {
		const { usuario } = this.props;
		const { selectedIds, batchEntregadorId } = this.state;
		const idList = [];
		const ks = Object.keys(selectedIds);
		for(let i = 0; i < ks.length; i++){
			if(selectedIds[ks[i]]) idList.push(ks[i]);
		}
		if(!idList.length){
			window.alert('Selecione ao menos uma entrega.');
			return;
		}
		if(!batchEntregadorId){
			window.alert('Selecione um entregador.');
			return;
		}
		if(!this.podeAtribuirLoteSelecionadas()){
			window.alert('Uma ou mais entregas ainda estão agendadas ou já saíram para entrega com lote ativo. Remova do lote (ou o X na coluna Lote) antes de atribuir outro. Para reentrega após "Pedido não entregue", não precisa remover: escolha o entregador e use Atribuir lote.');
			return;
		}
		this.props.loteAtribuir(usuario.loja, idList, batchEntregadorId)
			.then((data) => {
				if(this._ehErroLote(data)) return;
				if(data && data.lote){
					window.alert('Lote ' + data.lote.codigo + ' criado e entregas atribuídas.');
					this.refreshList();
				}
			});
	}

	handleNotificarWhatsApp = () => {
		const { usuario } = this.props;
		const r = this.getWhatsAppSelecaoValida();
		if(r.erro){
			window.alert(r.erro);
			return;
		}
		this.props.loteNotificarWhatsApp(usuario.loja, { entregaIds: r.entregaIds })
			.then((data) => {
				if(this._ehErroLote(data)) return;
				if(data && data.whatsappUrl){
					openWhatsAppUrl(data.whatsappUrl);
				}
			});
	}

	handleSaiuParaEntrega = () => {
		const { usuario } = this.props;
		const idList = [];
		const sel = this.state.selectedIds;
		const keys = Object.keys(sel);
		for(let k = 0; k < keys.length; k++){
			if(sel[keys[k]]) idList.push(keys[k]);
		}
		if(!idList.length){
			window.alert('Selecione ao menos uma entrega.');
			return;
		}
		this.props.loteSaiuParaEntrega(usuario.loja, idList)
			.then((data) => {
				if(this._ehErroLote(data)) return;
				window.alert('Status atualizado para "Saiu para Entrega".');
				this.refreshList();
			});
	}

	render(){
		const { entregas, usuario, bairrosEntregas, entregadoresLista, entregasResumo } = this.props;
		const { bairroFiltro, statusFiltro, semLoteFiltro, selectedIds, dataInicio, dataFim, pesquisa, filtrosExtrasAbertos, refreshing } = this.state;

		const dados = [];
		(entregas ? entregas.docs : []).forEach((entrega) => {
			if(!entrega) return null;
			const loteCod = entrega.loteAtual && entrega.loteAtual.codigo ? entrega.loteAtual.codigo : '—';
			const podeDes = this.podeDesatribuirLote(entrega);
			const clienteNome = entrega.pedido && entrega.pedido.cliente && entrega.pedido.cliente.nome
				? entrega.pedido.cliente.nome
				: "—";
			const entregadorNome = entrega.entregador && entrega.entregador.nome
				? entrega.entregador.nome
				: "—";
			dados.push({
				"ID": entrega.simpleId ? entrega.simpleId : entrega._id,
				"Cliente": clienteNome,
				"Lote": (
					<span className="entregaCell-lote" onClick={(e) => e.stopPropagation()}>
						<span className="entregaCell-loteCod">{loteCod.split('-').pop()}</span>&nbsp;
						{ podeDes && (
							<button
								type="button"
								className="entregaCell-loteBtn"
								title="Desatribuir"
								onClick={(e) => {
									e.stopPropagation();
									this.handleDesatribuirLote(entrega._id);
								}}
							>
								X
							</button>
						) }
					</span>
				),
				"Situação": (
					<div className="status">
						<span
							className={entregaStatusListagemPayClass(entrega)}
							title={entrega.status === ENTREGA_AGENDADA && entrega.loteAtual ? "Entrega agendada com lote atribuído" : undefined}
						>
							{entregaStatusListagemLabel(entrega)}
						</span>
					</div>
				),
				"Data Entrega": entrega.shippingDate,
				"Período": entrega.shippingPeriod.slice(0,5),
				"Entregador": entregadorNome,
				"Seen": entrega.pedido && entrega.pedido.seen,
				entrega
			});
		});

		const pageEntregaIds = [];
		for(let p = 0; p < dados.length; p++){
			if(dados[p].entrega && dados[p].entrega._id && this.entregaPodeSelecionar(dados[p].entrega)){
				pageEntregaIds.push(String(dados[p].entrega._id));
			}
		}

		let selectedCount = 0;
		const selKeys = Object.keys(selectedIds);
		for(let s = 0; s < selKeys.length; s++){
			if(selectedIds[selKeys[s]]) selectedCount++;
		}

		const bairrosLista = Array.isArray(bairrosEntregas) ? bairrosEntregas : [];
		const entregadoresOpts = (Array.isArray(entregadoresLista) ? entregadoresLista : []).filter((e) => e.ativo);

		const whatsappOk = this.podeNotificarWhatsAppLote();
		const podeAtribuirLoteBtn = this.podeAtribuirLoteSelecionadas();
		const podeRemoverDoLoteBtn = this.algumaSelecionadaPodeDesatribuirLote();

		return (
			<>
				{ entregas ? (
					<div className="SectionDelivery">

						<div className="Page-Title">
							<Titulo tipo="h1" titulo="Entregas"/>
						</div>

						<EntregasDashboardCards
							resumo={entregasResumo}
							onCardClick={this.onDashboardCardClick}
							statusFiltro={statusFiltro}
							semLoteFiltro={semLoteFiltro}
						/>

						<div className="entregasToolbar">
							<div className="entregasToolbarTop">
								<button
									type="button"
									className="entregasToolbarToggle"
									onClick={() => this.setState({ filtrosExtrasAbertos: !this.state.filtrosExtrasAbertos })}
									aria-expanded={filtrosExtrasAbertos}
									aria-label="Abrir ou fechar filtros adicionais"
								>
									<div className={`icon icon-toggle${filtrosExtrasAbertos ? ' active' : ''}`}>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</button>
								<Link to="/entregadores" className="btnIcon btnIconEntregadores" title="Cadastro de entregadores">
									<i className="fas fa-motorcycle"></i>
								</Link>
								{ verifyAdmin(usuario, 'owner') && (
									<button
										type="button"
										className="btnIcon btnIconPurgeAntigas"
										title="Excluir entregas anteriores a uma data — qualquer situação; apenas proprietário"
										aria-label="Excluir entregas anteriores a uma data"
										onClick={this.handlePurgeEntregasAntigas}
									>
										<i className="fas fa-trash-alt" aria-hidden="true" />
									</button>
								) }
								<div className="entregasToolbarSearchWrap">
									<Pesquisa
										valor={pesquisa}
										placeholder="ID, simpleId, cliente, código ou ID do lote"
										onChange={this.onChangePesquisa}
										onClick={() => this.handleSubmitPesquisa()}
										style={{ margin: 0 }}
									/>
								</div>
							</div>
							{filtrosExtrasAbertos ? (
								<div className="entregasFiltersDrawer">
									<div className="entregasFiltersExtrasItems">
										<label className="entregasFiltersPanel-field">
											<span>Bairro</span>
											<select value={bairroFiltro} onChange={this.onBairroChange}>
												<option value="">Todos</option>
												{ bairrosLista.map((b) => (
													<option key={b} value={b}>{b}</option>
												)) }
											</select>
										</label>
										<label className="entregasFiltersPanel-field">
											<span>Situação</span>
											<select value={semLoteFiltro ? SEM_LOTE_SELECT : statusFiltro} onChange={this.onSituationFilterChange}>
												<option value="">Todas</option>
												<option value={SEM_LOTE_SELECT}>Sem lote (agendada / reentrega)</option>
												{ LISTA_SITUACOES.map((s) => (
													<option key={s} value={s}>{s}</option>
												)) }
											</select>
										</label>
										<label className="entregasFiltersPanel-field">
											<span>Entregador</span>
											<select value={this.state.filtroEntregadorId} onChange={this.onFiltroEntregadorChange}>
												<option value="">Todos</option>
												{ entregadoresOpts.map((e) => (
													<option key={e._id} value={e._id}>{e.nome}</option>
												)) }
											</select>
										</label>
										<label className="entregasFiltersPanel-field">
											<span>Período</span>
											<select value={this.state.periodoEntregaFiltro} onChange={this.onPeriodoEntregaChange}>
												<option value="">Todos</option>
												{ PERIODOS_ENTREGA_FILTRO.map((p) => (
													<option key={p.value} value={p.value}>{p.label}</option>
												)) }
											</select>
										</label>
										<label className="entregasFiltersPanel-field entregasFiltersPanel-field--date">
											<span>De</span>
											<input type="date" value={dataInicio} onChange={this.onDataInicioChange} />
										</label>
										<label className="entregasFiltersPanel-field entregasFiltersPanel-field--date">
											<span>Até</span>
											<input type="date" value={dataFim} onChange={this.onDataFimChange} />
										</label>
									</div>
									<div className="entregasFiltersDrawer-footer">
										<button type="button" className="entregasLimparFiltrosBtn" onClick={this.limparFiltrosEntregas}>
											Limpar filtros
										</button>
									</div>
								</div>
							) : null}
						</div>

						{ statusFiltro === PEDIDO_NAO_ENTREGUE && (
							<p className="entregasFiltersHint">Reentrega: selecione as entregas, escolha o entregador e use <strong>Atribuir lote</strong> (não é necessário remover do lote atual) → <strong>WhatsApp</strong> → <strong>Saiu para entrega</strong>.</p>
						) }
						{ (dataInicio && !dataFim) || (!dataInicio && dataFim) ? (
							<p className="entregasFiltersHint">Para filtrar por período, preencha as duas datas (de e até).</p>
						) : null }

						{ selectedCount > 0 && (
							<p className="entregasFiltersHint batchDeliveryBar-hint" style={{ marginBottom: 8 }}>
								<strong>WhatsApp:</strong> mesmo entregador (lotes podem ser diferentes).
							</p>
						) }
						{ selectedCount > 0 && (
						<div className="batchDeliveryBar">
							<span className="batchDeliveryBar-count">{selectedCount} selecionada(s)</span>
							<div className="batchDeliveryBar-loteCol">
								<label className="batchDeliveryBar-fieldLabel" htmlFor="batchDeliveryEntregador">Entregador (lote)</label>
								<div className="batchDeliveryBar-controlsRow">
									<select
										id="batchDeliveryEntregador"
										value={this.state.batchEntregadorId}
										onChange={this.onBatchEntregadorChange}
										disabled={!podeAtribuirLoteBtn}
									>
										<option value="">Escolha o entregador</option>
										{ entregadoresOpts.map((e) => (
											<option key={e._id} value={e._id}>{e.nome}</option>
										)) }
									</select>
									<div className="batchDeliveryBar-primaryActions">
										<button
											type="button"
											className="batchDeliveryBar-btn batchDeliveryBar-btn--secondary"
											onClick={this.handleDesatribuirLoteSelecionadas}
											disabled={!selectedCount || !podeRemoverDoLoteBtn}
											title="Opcional: remove do lote para trocar entregador quando a entrega ainda está agendada ou saiu para entrega. Após 'Pedido não entregue', use Atribuir lote direto para reentrega."
										>
											Remover do lote
										</button>
										<button type="button" className="batchDeliveryBar-btn batchDeliveryBar-btn--primary" onClick={this.handleLoteAtribuir} disabled={!selectedCount || !this.state.batchEntregadorId || !podeAtribuirLoteBtn}>
											Atribuir lote
										</button>
										<button type="button" className="batchDeliveryBar-btn batchDeliveryBar-btn--primary" onClick={this.handleNotificarWhatsApp} disabled={!selectedCount || !whatsappOk}>
											WhatsApp (lote)
										</button>
										<button type="button" className="batchDeliveryBar-btn batchDeliveryBar-btn--primary" onClick={this.handleSaiuParaEntrega} disabled={!selectedCount}>
											Saiu para entrega
										</button>
									</div>
								</div>
							</div>
							<div className="batchDeliveryBar-secondary">
								<span className="batchDeliveryBar-secondaryLabel">Seleção na lista</span>
								<div className="batchDeliveryBar-secondaryBtns">
									<button type="button" className="batchDeliveryBar-btn batchDeliveryBar-btn--secondary" onClick={this.clearSelection} disabled={!selectedCount}>
										Limpar seleção
									</button>
									<button type="button" className="batchDeliveryBar-btn batchDeliveryBar-btn--secondary" onClick={this.togglePageSelection} disabled={!pageEntregaIds.length}>
										Selecionar / desmarcar página
									</button>
									<button type="button" className="batchDeliveryBar-btn batchDeliveryBar-btn--secondary" onClick={this.selectAllDoBairro} disabled={!bairroFiltro}>
										Selecionar todas do bairro
									</button>
								</div>
							</div>
						</div>
						) }

						{ refreshing && dados.length === 0 ? (
							<div className="entregasListaSkeleton" role="status" aria-busy="true" aria-label="Carregando lista de entregas">
								<div className="entregasListaSkeleton-head" />
								<div className="entregasListaSkeleton-body">
									{ [0, 1, 2, 3, 4, 5, 6, 7].map((k) => (
										<div key={k} className="entregasListaSkeleton-row" />
									)) }
								</div>
							</div>
						) : null }
						{ dados.length > 0 ? (
						<DynamicTable
							admin={usuario}
							cabecalho={["ID","Cliente","Entregador","Lote","Data Entrega","Período","Situação"]}
							refreshState={refreshing}
							dados={dados}
							refreshList={() => this.refreshList()}
							batchMode
							selectedIds={selectedIds}
							onToggleSelect={this.toggleSelect}
							onTogglePageSelect={this.togglePageSelection}
							pageEntregaIds={pageEntregaIds}
							batchRowSelectable={(linha) => linha.entrega && this.entregaPodeSelecionar(linha.entrega)}
							renderDetalhesExtra={(linha) => (
								<EntregaDetalhesExpand linha={linha} loja={usuario.loja} />
							)}
						/>
						) : !refreshing ? (
							<p className="entregasListaVazia">Nenhuma entrega encontrada com os filtros atuais.</p>
						) : null }

						{ dados.length > 0 ? (
						<Paginacao atual={this.state.atual}
							total={entregas ? entregas.total : 0}
							limite={this.state.limit}
							onClick={(numeroAtual) => this.changeNumeroAtual(numeroAtual)}/>
						) : ('')}
					</div>
				) : (<Loading />)}
			</>
		);
	}
}

const mapStateToProps = state => ({
	entregas: state.entrega.entregas,
	entregasResumo: state.entrega.entregasResumo,
	usuario: state.auth.usuario,
	bairrosEntregas: state.entrega.bairrosEntregas,
	entregadoresLista: state.entregador.lista,
});

export default connect(mapStateToProps, { ...entregaActions, getEntregadores })(Entregas);
